// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import VueResource from 'vue-resource'
import VueLanguage from 'vue-multilanguage'
import colors from 'vuetify/es5/util/colors'
import translate from './translate/index'
import VeeValidate, { Validator } from 'vee-validate'
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete'
import moment from 'moment'
import store from './store'
import { messages } from 'vee-validate/dist/locale/pt_BR'
import Decimal from 'decimal.js';
import VueEditor from 'vue2-editor'
import VueQuillEditor from 'vue-quill-editor'

Vue.use(VueQuillEditor)

Vue.prototype.moment = moment

window.$ = window.jQuery = require('jquery')
require('font-awesome/css/font-awesome.min.css')

router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

Vue.router = router
Vue.use(VuetifyGoogleAutocomplete, {
  apiKey: 'AIzaSyDK8GZ5VV1Wkk6jhFEAvbDL8ajhVDvarCU' // Can also be an object. E.g, for Google Maps Premium API, pass `{ client: <YOUR-CLIENT-ID> }`
  // version: '...', // Optional
})
Vue.use(VueResource)
Vue.use(VeeValidate)
Vue.use(VueEditor)

// Configuração global de interceptadores
Vue.http.interceptors.push((request, next) => {
  // Antes de enviar a requisição

  // Adicione headers comuns, se necessário
  // request.headers.set('Authorization', 'Bearer seu_token_aqui')

  // Continue com a próxima etapa
  next(response => {
    // Após receber a resposta

    // Lógica para tratamento de erros
    if (response.status >= 400) {
      console.error('Erro na requisição:', response.status, response.body);
    }
  })
})

// Configura o VeeValidate com as mensagens em português
Validator.localize('pt_BR', { messages })

Vue.use(VueLanguage, translate)
Vue.use(Vuetify, {
  theme: {
    primary: colors.green.darken3, // #E53935
    secondary: colors.blue.darken3, // #FFCDD2
    accent: colors.indigo.base // #3F51B5
  }
})
Vue.use(require('@websanova/vue-auth'), {
  refreshData: { enabled: false, interval: 0 },
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  rolesVar: 'type'
})

// Validator.localize('pt_BR', ptBR)
Vue.http.options.root = process.env.API

Vue.config.productionTip = false

Vue.filter('formatPercentage', function (value) {
  if (value) {
    return new Decimal(value).toDP(15).toString();
  } else if (value === 0) {
    return '0';
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm:ss')
  }
})

Vue.filter('formatCPF', function (value) {
  if (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, '$1.$2.$3-$4')
  }
})

Vue.filter('formatCpfCnpj', function (valor) {
  if (valor && valor.length === 11) {
    // Aplica a máscara de CPF
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
  } else if (valor && valor.length === 14) {
    // Aplica a máscara de CNPJ
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
  } else {
    return valor
  }
})

Vue.filter('formatCurrency', function (value) {
  if (typeof value !== 'number') {
    return value
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

Vue.filter('formatDouble', function (value) {
  if (!value) return ''
  return parseFloat(value).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})
// -------- Validations -------------------
// Validar se o valor é positivo
Validator.extend('positiveNumber', {
  getMessage: field => `O campo ${field} deve ter um valor positivo.`,
  validate: value => {
    console.log(value); // Adicionando console.log para depurar o valor
    return {
      valid: value >= 0
    };
  }
});


// Validar se o campo é obrigatório
Validator.extend('requiredNumber', {
  getMessage: field => `O campo ${field} é obrigatório.`,
  validate: value => {
    return {
      valid: value !== "" && value !== 0
    };
  }
});

Validator.extend('currentYear', {
  getMessage: (field, [year]) => {
    return `O ano do campo ${field} deve ser igual ao Ano Base ${year}.`;
  },
  validate: (value, [year]) => {
    const dateParts = value.split('/');
    const currentYear = parseInt(dateParts[2]);
    const isValid = !isNaN(currentYear) && currentYear === parseInt(year);

    console.log("dateParts", dateParts, "currentYear", currentYear, "year", year, "isValid", isValid)

    return isValid;
  }
});


Validator.extend('validCpf', {
  getMessage: field => `O campo ${field} é inválido.`,
  validate: cpf => new Promise((resolve) => {
    let numericCpf = cpf.replace(/\D/g, '')
    let result = true
    if (!numericCpf || numericCpf.length != 11
      || numericCpf == "00000000000"
      || numericCpf == "11111111111"
      || numericCpf == "22222222222"
      || numericCpf == "33333333333"
      || numericCpf == "44444444444"
      || numericCpf == "55555555555"
      || numericCpf == "66666666666"
      || numericCpf == "77777777777"
      || numericCpf == "88888888888"
      || numericCpf == "99999999999")
      result = false
    let soma = 0
    let resto
    for (let i = 1; i <= 9; i++)
      soma = soma + parseInt(numericCpf.substring(i - 1, i)) * (11 - i)
    resto = (soma * 10) % 11
    if ((resto == 10) || (resto == 11)) resto = 0
    if (resto != parseInt(numericCpf.substring(9, 10))) result = false
    soma = 0
    for (let i = 1; i <= 10; i++)
      soma = soma + parseInt(numericCpf.substring(i - 1, i)) * (12 - i)
    resto = (soma * 10) % 11
    if ((resto == 10) || (resto == 11)) resto = 0
    if (resto != parseInt(numericCpf.substring(10, 11))) result = false

    resolve({
      valid: result
    })
  })
})

Validator.extend('validCnpj', {
  getMessage: field => `O campo ${field} é inválido.`,
  validate: cnpj => new Promise((resolve) => {
    let numericCnpj = cnpj.replace(/\D/g, '')
    let result = true
    if (!numericCnpj || numericCnpj.length != 14
      || numericCnpj == "00000000000000"
      || numericCnpj == "11111111111111"
      || numericCnpj == "22222222222222"
      || numericCnpj == "33333333333333"
      || numericCnpj == "44444444444444"
      || numericCnpj == "55555555555555"
      || numericCnpj == "66666666666666"
      || numericCnpj == "77777777777777"
      || numericCnpj == "88888888888888"
      || numericCnpj == "99999999999999")
      result = false
    let tamanho = numericCnpj.length - 2
    let numeros = numericCnpj.substring(0, tamanho)
    let digitos = numericCnpj.substring(tamanho)
    let soma = 0
    let pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
    if (resultado != digitos.charAt(0)) result = false;
    tamanho = tamanho + 1
    numeros = numericCnpj.substring(0, tamanho)
    soma = 0
    pos = tamanho - 7
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--
      if (pos < 2) pos = 9
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
    if (resultado != digitos.charAt(1)) result = false
    resolve({
      valid: result
    })
  })
})

Validator.extend('validCAEPF', {
  getMessage(field, params, data) {
    return (data && data.message) || `O campo ${field} é inválido.`;
  },
  validate: value => new Promise((resolve) => {
    const caepf = String(value).replace(/[^0-9]*/g, "");
    if (caepf.length !== 14) {
      return false;
    }
    const caepfBase = caepf.slice(0, 12);
    const digitosReverse = [...caepfBase]
      .reverse()
      .reduce((previousValue, currentValue) => {
        previousValue.push(Number(currentValue));
        return previousValue;
      }, []);
    const calcModuleDV = (array, nModuleInit = 9, nModuleMin = 2) => {
      let nModule = 9;
      let result = 0;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        result += element * nModule;
        nModule > nModuleMin ? (nModule = nModule - 1) : (nModule = nModuleInit);
      }
      result = result % 11;
      if (result === 10) {
        result = 0;
      }
      return result;
    };
    const firstDigitDV = calcModuleDV(digitosReverse);
    const lastDigitDV = calcModuleDV([firstDigitDV].concat(digitosReverse));
    let resultDV = firstDigitDV * 10 + lastDigitDV + 12;
    if (resultDV > 99) {
      resultDV = resultDV - 100;
    }
    let resultDVString = "";
    if (resultDV == 0) {
      resultDVString = "00";
    } else if (resultDV > 0 && resultDV < 10) {
      resultDVString = `0${resultDV}`;
    } else {
      resultDVString = String(resultDV);
    }
    const validCAEPF = `${caepfBase}${resultDVString}`;

    // Verificar se o dígito verificador calculado é igual ao dígito verificador informado
    const isValid = caepf === validCAEPF

    if (!isValid) {
      resolve({
        valid: false,
        data: { message: 'Por favor, verifique os valores inseridos. O CAEPF informado é inválido.' }
      });
    }

    resolve({ valid: true })
  })
})

Validator.extend('_validCAEPF', {
  getMessage: field => `O campo ${field} é inválido.`,
  validate: caepf => {
    caepf = caepf.replace(/\D/g, ""); // Remover caracteres não numéricos
    const primeiros12Digitos = caepf.substring(0, 12);

    // Verificar se o CAEPF possui 12 dígitos
    if (primeiros12Digitos.length !== 12) {
      return {
        valid: false,
        data: { message: 'O CAEPF deve conter exatamente 12 dígitos.' }
      };
    }

    // Calcular o dígito verificador
    let soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(caepf.charAt(i)) * (11 - i);
    }
    let resto = (soma * 10) % 11;
    if (resto === 10) {
      resto = 0;
    }

    // Verificar se o dígito verificador calculado é igual ao dígito verificador informado
    const isValid = parseInt(caepf.charAt(10)) === resto;

    if (!isValid) {
      return {
        valid: false,
        data: { message: 'Por favor, verifique os valores inseridos. O CAEPF informado é inválido.' }
      };
    }

    return { valid: true };
  }
});

// ---------------------------------


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
  methods: {
    merge(a, b, prop) {
      var reduced = a.filter(aitem => !b.find(bitem => aitem[prop] === bitem[prop]))
      return reduced.concat(b)
    },
    cloneObject(object) {
      return Object.assign({}, object)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js